const menuConfig = [
    {linkName: 'Flights', linkHref: '/flights'},
    {linkName: 'Weather', linkHref: '/weather'},
    {linkName: 'SigCharts', linkHref: '/sigcharts'}
]

export default menuConfig


// WEBPACK FOOTER //
// ./src/config/menuConfig.js